// extracted by css-extract-rspack-plugin
export default {"container":"_d42d85d2","divider":"_602e6b54"};